<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { Article } from '~/types';
import { useArticle } from '~/composables/useArticle';
import Image from '~/components/ui/Image.vue';

interface Props {
  article: Article.Model;
}

const props = defineProps<Props>();

const { featuredImageSrcSet, title, articleDate, permalink, shortDescription } = useArticle(props.article);
</script>

<template>
  <div class="latest-post-item">
    <Link :href="permalink" class="latest-post-item__thumb">
      <Image v-if="featuredImageSrcSet?.src" :image="featuredImageSrcSet" class="latest-post-item__image" />
    </Link>
    <div class="latest-post-item__body">
      <strong class="latest-post-item__date">
        <time>{{ articleDate }}</time>
      </strong>
      <h3 class="latest-post-item__title">
        <Link :href="permalink" class="latest-post-item__title-link">{{ title }}</Link>
      </h3>
      <p v-if="shortDescription" class="latest-post-item__description">
        {{ shortDescription }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.latest-post-item {
  @apply w-full flex flex-col gap-4;

  &__thumb {
    @apply relative aspect-[4/3] w-full block rounded-20 overflow-hidden;
  }

  &__image {
    @apply absolute w-full h-full inset-0 object-cover object-center duration-300 hover:scale-105;
  }

  &__body {
    @apply flex flex-col gap-3;
  }

  &__title {
    @apply text-[20px] leading-[1.1] font-medium;
    @apply 2xl:text-[24px];

    &-link {
      @apply duration-300 hover:text-accent;
    }
  }

  &__date {
    @apply text-accent text-[16px] font-medium;
  }
}
</style>
